<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="contipogasto"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmtipogasto" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-col-12">
    <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
        [botonRegresar]="btnRegresar" [botonPrimero]="btnPrimero" [botonAnterior]="btnAnterior"
        [botonSiguiente]="btnSiguiente" [botonUltimo]="btnUltimo" [barraBotonesCRUD]="false"
        [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true" [barraBotones5]="true"
        [botonBuscar]="false" (signal)="manejarSenales($event)"></app-invmaebarra>


</div>

<div style="overflow: hidden" class="p-col-12">
	<p-tabView>
		<p-tabPanel header="Tipos de gastos">
			<app-aggridsaci [width]=""
							[height]="largo"
							[enableSorting]="false"
							[enableFilter]="true"
							[rowData]="conmaetipgasto"
							[frameworkComponents]="frameworkComponents"
							[animateRows]="true"
							[rowSelection]="rowSelection"
							[columnDefs]="columnDefConMaeTipgasto"
							[defaultColDef]="defaultColDefconmaetipgasto"
							[rowStyle]="rowStyle"
							[singleClickEdit]="false"
							[botones]="false"
							(selected)=selectConMaeTipo($event)
							(cambios)="cambioModulo($event)"

			></app-aggridsaci>
		</p-tabPanel>
	</p-tabView>
</div> 